import {
    GenericFormContainer,
    Grid,
    IAlertData,
    Leap4Breadcrumbs,
    setAlert,
    Spinner,
    Mode,
    MuiIcons,
    Toc as TocIcon
} from "@leap4/frontend";
import {EditGroupStore} from "./EditGroupStore";
import {useHistory, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import {ApiClient} from "../../../../../utils/apiClient";
import {GroupsBaseUrl} from "../../../../../config/generals";
import {urlService} from "../../../../routing/urlsService";
import {DetailsForm} from "../base/DetailsForm";
import {RootState} from "../../../../../store/store";
import {connect} from "react-redux";
import {IGroup} from "../../interfaces/IGroup";
import {initialGroupObj} from "../base/Group";
import { GroupContext } from "../base/GroupContex";
import {Server} from "@leap4/auth";
import {OneOrgOnly} from "../../../../shared/OneOrgOnly/OneOrgOnly";

const {Groups: GroupsIcon} = MuiIcons;

export interface IEditGroupProps {
    setGroup: (data: IAlertData) => void;
}


let editGroupStore: EditGroupStore


const _editGroup = (props: IEditGroupProps) => {
    const history = useHistory();
    const params = useParams<{ id?: string }>();
    const [group, setGroup] = useState<IGroup>(initialGroupObj);
    const groupContextValue = useMemo(() => ({group, setGroup}), [group]);
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadError, setIsLoadError] = useState(false)


    useEffect(() => {
        if (!params.id) {
            return;
        }
        editGroupStore = new EditGroupStore({
                setIsLoading,
                setIsLoadError,
                setItem: setGroup,
                axiosClient: ApiClient,
                alertFunc: props.setGroup,
                baseUrl: `${GroupsBaseUrl}`
            }
        )
        editGroupStore.refreshItem(params.id)
    }, [params.id])


    const onSubmit = async () => {
        if (!group._id) {
            return;
        }
        await editGroupStore.updateById(group._id.toString(), group);
        history.push(urlService.groups());
    };

    const onDelete = async () => {
        if (!group || !group._id) {
            return
        }
        await editGroupStore.deleteItem(group._id.toString());
        history.push(urlService.groups());
    };

    if (isLoadError) {
        return (<>Error Loading the page</>);
    }
    if (isLoading) {
        return (<Spinner/>);
    }

    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }

    return (
        <>
            <Leap4Breadcrumbs breadcrumbs={[{
                text: "Alerts Dashboard",
                link: urlService.alerts(),
                icon: <TocIcon/>
            },
                {
                    text: group.name,
                    icon: <GroupsIcon/>
                }]}
            />
            <GenericFormContainer mode={Mode.Edit} onCreateOrEditFunc={onSubmit} onDeleteFunction={onDelete}>
                <GroupContext.Provider value={groupContextValue}>
                    <DetailsForm mode={"edit"} />
                </GroupContext.Provider>
            </GenericFormContainer>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({});

export const EditGroup = connect(mapStateToProps, {
    setGroup: setAlert
})(_editGroup);